class Page {
  static soribot = '/soribot';
  static my_soribots = '/my_soribots';
  static publicSharePage = '/share'; // Public external sharing.
  static publicBotPage = '/b'; // Standalone Soribot page.
}

export default Page;